'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectOverviewCtrl', ProjectOverviewCtrl);

  ProjectOverviewCtrl.$inject = ['$scope', 'project', 'Auth', 'errorMessageService',
    'ProjectBusinessService', 'Constants', 'Labels', 'PvETemplateAPI', 'sg2AuthService'];

  function ProjectOverviewCtrl ($scope, project, Auth, errorMessageService, ProjectBusinessService,
    Constants, Labels, PvETemplateAPI, sg2AuthService) {

    $scope.LABELS = Labels;

    $scope.PROJECT_LEVELS = {};
    Constants.getList('PROJECT_LEVELS').forEach(function (projectLevel) {
      $scope.PROJECT_LEVELS[projectLevel.value] = projectLevel;
    });

    $scope.KNOWLEDGE_LEVELS = {};
    Constants.getList('KNOWLEDGE_LEVELS').forEach(function (knowledgelevel) {
      $scope.KNOWLEDGE_LEVELS[knowledgelevel.value] = knowledgelevel;
    });

    $scope.QUALITY_LEVELS = {};
    Constants.getList('QUALITY_LEVELS').forEach(function (qualitylevel) {
      $scope.QUALITY_LEVELS[qualitylevel.value] = qualitylevel.displayName;
    });

    $scope.STATUS_TYPES = {};
    Constants.getList('STATUS_TYPES').forEach(function (status) {
      $scope.STATUS_TYPES[status.name] = status.displayName;
    });

    $scope.projectKnowledgeLevels = Constants.getList('KNOWLEDGE_LEVELS').filter(function (level) {
      return level.projectLevels.indexOf(1) > -1;
    });
    $scope.project = project;

    $scope.buildingKnowledgeLevels = Constants.getList('KNOWLEDGE_LEVELS').filter(function (level) {
      return level.projectLevels.indexOf(2) > -1;
    });

    const elements = JSON.parse(JSON.stringify(ProjectBusinessService.getElements($scope.project)));

    $scope.progress = Constants.getList('STATUS_TYPES').map((status) => {
      const matchingElements = elements.filter((element) => element.status === status._id);
      return Object.assign(status, {
        elements: matchingElements,
        absoluteProgress: matchingElements.length,
        relativeProgress: matchingElements.length / elements.length
      });
    });

    /**
     * Add the template date based on the project.templateId
     * @param templateId ID of the project template
     */
    const getProjectTemplate = (templateId: string) => {
      return PvETemplateAPI.get({ id: templateId }).$promise;
    };

    $scope.project.projectTemplate = getProjectTemplate($scope.project.templateId).then((tmpl) => {
      return Promise.resolve(tmpl);
    });

    // Right to view the project widget
    const readOverviewProject = sg2AuthService.canRead('overview-project')
    // Right to view the progress widget
    const readOverviewProgress = sg2AuthService.canRead('overview-progress')
    // Right to view the team widget
    const readOverviewTeam = sg2AuthService.canRead('overview-team')
    // Right to view the comments widget
    const readOverviewComments = sg2AuthService.canRead('overview-comments')
    // Right to view the activities widget
    const readOverviewActivities = sg2AuthService.canRead('overview-activities')
    // Right to view the assigned widget
    const readOverviewAssigned = sg2AuthService.canRead('overview-assigned')
    // Right to view the download widget
    const readOverviewDownload = sg2AuthService.canRead('overview-download')
    // Right to view the arealist widget
    const readOverviewArealist = sg2AuthService.canRead('overview-arealist')

    // right to use the progress filter and go to the element&filter page
    $scope.updateOverviewProgress = sg2AuthService.canUpdate('overview-progress')
    // right to add and remove users to the project team
    $scope.updateOverviewTeam = sg2AuthService.canUpdate('overview-team')

    let widgetCount = 0;
    $scope.wObject = [];
    
    if (readOverviewProject) {
      $scope.wObject.push({
          type: 'template',
          templateUrl: 'app-legacy/project/overview/widgets/info/widget-project-info.html',
          classes: 'widget__padding--none',
          grid: {
            'mdColspan' : 1,
            'mdColspanSm': 1,
            'mdColspanMd': 1,
          }});
      widgetCount++;
    }

    if (readOverviewProgress) {
      $scope.wObject.push({
        title: $scope.LABELS.getLabel('progress'),
        titleIcon: 'assessment',
        type: 'template',
        templateUrl: 'app-legacy/project/overview/widgets/overview/widget-project-overview.html',
      });
      widgetCount++;
    }

    if (readOverviewTeam) {
      $scope.wObject.push({
        title: $scope.LABELS.getLabel('teamoverview'),
        titleIcon: 'people',
        type: 'template',
        templateUrl: 'app-legacy/project/overview/widgets/team/widget-project-team.html',
      });
      widgetCount++;
    }

    if (readOverviewComments) {
      $scope.wObject.push({
        title: $scope.LABELS.getPlural('comment'),
        titleIcon: 'comment',
        // toolbar: ['question', 'minimize'],
        type: 'template',
        templateUrl: 'app-legacy/project/overview/widgets/comments/widget-project-comments.html',
      });
      widgetCount++;
    }

    if (readOverviewActivities) {
      $scope.wObject.push({
        title: $scope.LABELS.getPlural('activity'),
        titleIcon: 'history',
        type: 'template',
        templateUrl: 'app-legacy/project/overview/widgets/log/widget-project-log.html',
      });
      widgetCount++;
    }

    if (readOverviewAssigned) {
      $scope.wObject.push({
        title: $scope.LABELS.getPlural('specificationassigned'),
        titleIcon: 'list_alt',
        type: 'template',
        templateUrl: 'app-legacy/project/overview/widgets/assigned-elements/widget-project-assigned-elements.html',
      });
      widgetCount++;
    }

    if (readOverviewDownload) {
      $scope.wObject.push({
        title: $scope.LABELS.getPlural('download'),
        titleIcon: 'picture_as_pdf',
        toolbar: ['question', 'minimize'],
        type: 'template',
        templateUrl: 'app-legacy/project/overview/widgets/documents/widget-project-documents.html',
      });
      widgetCount++;
    }

    if (readOverviewArealist) {
      let maxColspan = 3;
      if (widgetCount % 3 === 0) {
        maxColspan = 3; 
      } else if  (widgetCount % 3 === 1) {
        maxColspan = 2;       
      } else {
        maxColspan = 1;
      }

      $scope.wObject.push({
        title: $scope.LABELS.getPlural('area'),
        titleIcon: 'meeting_room',
        type: 'template',
        templateUrl: 'app-legacy/project/overview/widgets/areas/widget-project-areas.html',
        grid: {
          'mdColspan' : maxColspan,
          'mdColspanSm': 1,
          'mdColspanMd': Math.max(maxColspan-1,1),
          'mdColspanGtMd': maxColspan
        }
      });
    }
  }

})();
